import React from 'react'
import classnames from 'classnames'
import { injectIntl } from 'react-intl'

const AggreagateReportAskPassword = ({ intl, pwd, passwordInvalid, onChangePwd, onSubmit, errorMessage }) => {
  const pwdProps = {
    value: pwd,
    onChange: onChangePwd,
    id: 'txtRptPwd',
    name: 'txtRptPwd',
    type: 'password',
    maxLength: 20,
    className: classnames('frontend-row-xx-sm  test-AggregateReportPubb-inputPsw', { 'is-error': passwordInvalid }),
    style: { width: '250px' },
    onKeyDown: onPwdKeyDown
  }

  const submitProps = {
    id: 'btnShowReport',
    name: 'btnShowReport',
    type: 'button',
    className: 'frontend_main-button frontend_button-is-left test-AggregateReportPubb-btnChangePsw',
    onClick: onSubmit
  }

  function onPwdKeyDown (e) {
    if (e.key === 'Enter') {
      onSubmit()
    }
  }

  return (
    <div className='frontend-box frontend-row'>
      {errorMessage &&
        <div className='message-feedback message-feedback_simple is-error'>{errorMessage}</div>}
      <h1 className='frontend-row'>{intl.formatMessage({ id: 'Load.Statistics.AggregateReport' })}</h1>
      <div className='frontend-row_reset frontend-row'>
        <span className='frontend-main-text frontend-m-right-thin'>{intl.formatMessage({ id: 'Load.MailupCommon.LabelPassword' })}</span>
        <input {...pwdProps} />
        <button {...submitProps}>{intl.formatMessage({ id: 'Load.MailupCommon.Send' })}</button>
      </div>
    </div>
  )
}

export default injectIntl(AggreagateReportAskPassword)
